import { SvgIcon } from '@bridebook/aura';
import { SVGProps } from 'react';

/**
 * Defines icon symbols once for the whole search grid.
 * Each card references via <use href="#icon-id"> instead of inlining the full SVG.
 *
 * It contains copies, as referencing existing SVG's was not possible.
 */
export const SearchGridSvgSprite = () => (
  <svg style={{ display: 'none' }} aria-hidden="true">
    {/* source: packages/aura/src/icons/build/budget.svg */}
    <symbol id="icon-budget" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.44 7.437C8.816 6.222 10.976 5.547 13.145 6m-5.06 14.1q-.267 0-.527-.008c-.74-.018-1.246-.397-1.464-1.097l-.306-.99a170 170 0 0 0-.682-2.18.9.9 0 0 0-.173-.304c-.716-.814-1.21-1.72-1.473-2.693a1.68 1.68 0 0 1-1.445-1.435 1.71 1.71 0 0 1 1.111-1.834c.078-.03.19-.07.325-.09.45-1.68 1.485-3.058 3.076-4.1 1.587-1.039 3.418-1.528 5.45-1.449a9.4 9.4 0 0 1 3.926 1.04 5 5 0 0 1 2.41-.445c.78.046 1.135.479 1.297.834.297.656-.053 1.176-.222 1.426-.174.257-.343.54-.514.857q.443.571.935 1.15c.043.003.107.001.17 0a3 3 0 0 1 .25 0c.99.04 1.749.802 1.765 1.773q.006.391.003.782l-.001.34-.002.29c-.002.198-.004.397.003.595.028.77-.277 1.423-.908 1.943-1.07.88-2.151 1.556-3.306 2.064a.4.4 0 0 0-.056.029l-.009.03c-.175.61-.367 1.22-.554 1.81l-.17.544c-.226.722-.725 1.096-1.484 1.111-.387.008-.73.008-1.048-.002-.72-.021-1.23-.409-1.438-1.092l-.057-.185q-.087-.279-.171-.567a10 10 0 0 1-2.492 0q-.098.337-.2.676l-.014.047c-.214.716-.728 1.105-1.484 1.123a23 23 0 0 1-.52.006m9.06-10.6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        vectorEffect="non-scaling-stroke"
      />
    </symbol>

    {/* source: packages/aura/src/icons/build/user-double.svg */}
    <symbol id="icon-user-double" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16 19h4a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-2m-2.236-4a3 3 0 1 0 0-4M3 18v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1m8-10a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
        vectorEffect="non-scaling-stroke"
      />
    </symbol>

    {/* source: packages/aura/src/icons/build/hotel.svg */}
    <symbol id="icon-hotel" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.5 21.622v-7c4.432-1.981 14.568-1.981 19 0v7M2.5 18.5h19M5.557 12.1a1.92 1.92 0 0 1 .23-1.9 14.6 14.6 0 0 1 4.72 0c.271.378.407.836.385 1.3m7.551.6a1.92 1.92 0 0 0-.23-1.9 14.6 14.6 0 0 0-4.72 0 2.06 2.06 0 0 0-.385 1.3m7.392 1.122v-5a14.7 14.7 0 0 0-3.5-.894m-10 0c-1.2.153-2.375.453-3.5.894v5M13.822 2.5A1.97 1.97 0 0 0 12 3.725 1.98 1.98 0 0 0 10.175 2.5 2.157 2.157 0 0 0 8.2 4.677C8.2 7.061 11.494 9 12 9s3.8-1.939 3.8-4.323A2.157 2.157 0 0 0 13.822 2.5"
        vectorEffect="non-scaling-stroke"
      />
    </symbol>

    {/* source: packages/ui/src/components/svg/icon-review-filled.tsx */}
    <symbol id="icon-review-star" viewBox="0 0 50 48">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M39.254 47.999c-.31 0-.619-.074-.902-.224L25 40.718l-13.352 7.057a1.921 1.921 0 0 1-2.04-.148 1.953 1.953 0 0 1-.772-1.905l2.55-14.948L.586 20.19a1.956 1.956 0 0 1-.491-1.998 1.94 1.94 0 0 1 1.563-1.325l14.928-2.18 6.676-13.6a1.934 1.934 0 0 1 3.476-.001l6.676 13.6 14.928 2.18a1.94 1.94 0 0 1 1.563 1.325c.228.706.038 1.48-.49 1.998L38.614 30.774l2.55 14.948c.124.73-.175 1.47-.772 1.905a1.922 1.922 0 0 1-1.138.372z"
      />
    </symbol>

    {/* source: packages/ui/src/components/svg/icon-img.tsx */}
    <symbol id="icon-img" viewBox="0 0 19 21">
      <path
        fill="currentColor"
        d="M10.4 7.2c1.3 0 2.3-1.1 2.3-2.3 0-1.3-1-2.3-2.3-2.3C9.1 2.5 8 3.6 8 4.9c0 1.2 1.1 2.3 2.4 2.3zm0-3.3c.5 0 .9.5.9 1s-.4.9-.9.9-.9-.5-.9-1 .4-.9.9-.9z"
      />
      <path
        fill="currentColor"
        d="M19.3 4c-.1-.1-.3-.2-.5-.3L16 3.3V.7c0-.4-.3-.7-.7-.7H.7C.3 0 0 .3 0 .7v14.6c0 .4.3.7.7.7h.7l-.1.5c-.1.4.2.7.6.8l14.4 2.2c.4.1.7-.2.8-.6l2.2-14.4c.1-.2.1-.4 0-.5zM1.4 1.4h13.2v10.7h-2.1c-.5-.6-3.9-4.4-4-4.5-.1-.2-.3-.3-.5-.3s-.4.1-.5.2L5.9 9.3 1.4 4.6V1.4zm0 5.2l4 4.2c.1.1.3.2.5.2s.4-.1.5-.2L8 9c.7.8 1.9 2.1 2.7 3.1H1.4V6.6zm0 8v-1.1h13.2v1.1H1.4zM15.9 18L2.8 16h12.5c.4 0 .7-.3.7-.7V4.6l1.9.3-2 13.1z"
      />
    </symbol>

    {/* source: packages/ui/src/components/svg/icon-chevron.tsx */}
    <symbol id="icon-chevron-down" viewBox="0 0 50 27">
      <path
        fill="currentColor"
        d="M25 27a2.563 2.563 0 0 1-1.794-.729L.744 4.248a2.453 2.453 0 0 1 0-3.519 2.573 2.573 0 0 1 3.588 0l20.669 20.264L45.669.73a2.572 2.572 0 0 1 3.587 0 2.453 2.453 0 0 1 0 3.519L26.795 26.27a2.563 2.563 0 0 1-1.794.729"
      />
    </symbol>

    {/* source: packages/ui/src/raw-svgs/featured-supplier.svg */}
    <symbol id="icon-featured-supplier" viewBox="0 0 45.5 34.4">
      <path
        fill="currentColor"
        d="M3.5 20.9V6.2l5.6 6.3c.8.9 2.1 1 3.1.2l11-8.8 10 8.7c.9.8 2.3.7 3.1-.2L42 6.2v14.7H3.5zM42 30.6c0 .1-.1.2-.2.2h-38c-.1 0-.2-.1-.2-.2v-6.2H42v6.2zM44.1.8c-.9-.3-1.8-.1-2.5.6l-7 7.8L24.7.6c-.8-.7-2-.7-2.9-.1L10.9 9.2l-7-7.8C3.3.7 2.3.4 1.4.8.6 1.1 0 1.9 0 2.9v27.7c0 2.1 1.7 3.7 3.8 3.7h38c2.1 0 3.7-1.7 3.8-3.7V2.9c-.1-1-.7-1.8-1.5-2.1z"
      />
    </symbol>

    {/* source: packages/aura/src/icons/build/heart-outline.svg */}
    <symbol id="icon-shortlist-variant" viewBox="0 0 24 24">
      <path
        fill="var(--icon-fill, none)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.8 4a5.23 5.23 0 0 0-2.89.878A5.17 5.17 0 0 0 12 7.204a5.17 5.17 0 0 0-1.913-2.328A5.23 5.23 0 0 0 7.194 4C4.326 4 2 6.84 2 9.694 2 15.93 10.666 21 12 21s10-5.07 10-11.306C22 6.84 19.674 4 16.8 4"
        vectorEffect="non-scaling-stroke"
      />
    </symbol>

    {/* source: packages/ui/src/components/svg/icon-location-filled.tsx */}
    <symbol id="icon-location-filled" viewBox="0 0 30 37">
      <path
        fill="currentColor"
        d="M25.65 4.44A15.19 15.19 0 0 0 14.9 0h-.05C6.65 0 0 6.33 0 14.07a13.67 13.67 0 0 0 2.18 7.37l.06.08 11.54 15.36a1.3 1.3 0 0 0 1 .52 1.29 1.29 0 0 0 1-.52l11.61-15.44.06-.09a13.78 13.78 0 0 0 2.17-7.27 13.45 13.45 0 0 0-3.97-9.64zM14.81 19.11a4.8 4.8 0 1 1 4.8-4.8 4.81 4.81 0 0 1-4.8 4.8z"
      />
    </symbol>

    {/* Quick Facts background swirls */}
    <symbol id="icon-swirl-purple" viewBox="0 0 195 158" fill="none">
      <path
        d="M3.14314 -16.1936C63.597 -6.89072 178.217 20.5895 153.065 56.0877C121.626 100.46 127.913 113.168 215.07 141.838"
        stroke="#DBDCF9"
        strokeWidth="33.7864"
      />
    </symbol>
    <symbol id="icon-swirl-green" viewBox="0 0 279 110" fill="none">
      <path
        d="M319.246 -6.8047C268.123 44.1744 159.8 131.332 135.489 72.1295C105.102 -1.87373 86.1924 -7.90232 -5.17688 50.8711"
        stroke="#DFF6F1"
        strokeWidth="33.7908"
      />
    </symbol>
    <symbol id="icon-swirl-orange" viewBox="0 0 178 143" fill="none">
      <path
        d="M217.546 125.947C148.985 105.703 21.4084 52.4794 59.5928 1.53314C107.323 -62.1496 103.074 -81.9596 7.97156 -134.153"
        stroke="#FCEED7"
        strokeWidth="33.7873"
      />
    </symbol>
    <symbol id="icon-swirl-red" viewBox="0 0 133 178" fill="none">
      <path
        d="M18.5801 295.419C14.5897 212.573 15.711 53.1419 52.1187 78.1844C97.6284 109.488 107.576 98.0613 115.289 -25.0317"
        stroke="#FFEEE8"
        strokeWidth="33.786"
      />
    </symbol>
  </svg>
);

const makeSpriteIcon = (id: string): SvgIcon => {
  const SpriteIcon = ({ width, height, className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg width={width} height={height} className={className} aria-hidden="true" {...props}>
      <use href={`#${id}`} />
    </svg>
  );
  SpriteIcon.displayName = `SpriteIcon(${id})`;
  return SpriteIcon;
};

export const ShortlistVariantSpriteIcon = makeSpriteIcon('icon-shortlist-variant');
export const BudgetSpriteIcon = makeSpriteIcon('icon-budget');
export const UserDoubleSpriteIcon = makeSpriteIcon('icon-user-double');
export const HotelSpriteIcon = makeSpriteIcon('icon-hotel');
export const ReviewStarSpriteIcon = makeSpriteIcon('icon-review-star');
export const GalleryImgSpriteIcon = makeSpriteIcon('icon-img');
export const ChevronDownSpriteIcon = makeSpriteIcon('icon-chevron-down');
export const FeaturedSupplierSpriteIcon = makeSpriteIcon('icon-featured-supplier');
export const LocationFilledSpriteIcon = makeSpriteIcon('icon-location-filled');
export const SwirlPurpleSpriteIcon = makeSpriteIcon('icon-swirl-purple');
export const SwirlGreenSpriteIcon = makeSpriteIcon('icon-swirl-green');
export const SwirlOrangeSpriteIcon = makeSpriteIcon('icon-swirl-orange');
export const SwirlRedSpriteIcon = makeSpriteIcon('icon-swirl-red');
